import { AppAction } from '../actions/app/action-creators';
import { AppActionType } from '../actions/app/action-types';
import { SystemEnvironment } from '@/constants/systemEnviroment';

export interface AppState {
  environment: SystemEnvironment;
}

export const initialAppState: AppState = {
  environment: SystemEnvironment.STAGING,
};

function appReducer(
  state: AppState = initialAppState,
  action: AppAction,
): AppState {
  switch (action.type) {
    case AppActionType.SET_ENVIRONMENT: {
      const payload = action.payload as {
        environment: SystemEnvironment;
      };

      return {
        ...state,
        environment: payload.environment,
      };
    }

    default:
      return state;
  }
}

export default appReducer;
